import Bowser from 'bowser';
import { v4 } from 'uuid';

const deviceId = v4();

export const getDeviceInfo = () => {
  return Bowser.parse(window.navigator.userAgent);
};

export const getDeviceUniqueId = () => {
  return deviceId;
};
